enum GalleryImageType {
  All = '',
  Exterior = 'exterior',
  Feature = 'feature',
  Imperfection = 'imperfection',
  SafetyFeature = 'safetyFeature'
}

export default GalleryImageType;
